import { render } from "./IconArrowLeft.vue?vue&type=template&id=21ee8566&scoped=true"
const script = {}

import "./IconArrowLeft.vue?vue&type=style&index=0&id=21ee8566&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ee8566"]])

export default __exports__